import React from "react";
import ArrowBack from "./Icons/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackArrow = ({ mt, ml }) => {
  const navigate = useNavigate();
  const marginStyle = {
    marginTop: mt,
    marginLeft: ml,
  };

  const goBack = () => navigate(-1);

  return (
    <div className={`flex mx-[29px] `} style={marginStyle} onClick={goBack}>
      <div className="flex items-center cursor-pointer">
        <ArrowBack />
        <span>Back</span>
      </div>
    </div>
  );
};

export default BackArrow;
